import React, {Fragment, useEffect, useRef, useState} from 'react';
import parse from 'html-react-parser';
import {mrbgStore, activeFormPanel, setSettingsForm, selectTagValue, updateNotification, setHideInp, setSundryField} from './mrbgRedux';
import {mrbgTools} from '../../mrbgLib/mrbgTools.js';
import {formsJson} from '../../mrbgLib/formsJson.js';
import mrbgS2S from '../../mrbgLib/mrbgS2S.js';
import MrbgFormsCreator from './MrbgFormsCreator.jsx';
import formStyle from '../../static/css/MP_forms.module.css';

function MrbgNotifications({headerStyle}){

	const
		refInp = useRef(),
		[searchVal ,setSearchVal ] = useState(''),
		[myNotif,setMyNotif] = useState(mrbgStore.getState().myNotifications),
		[micCls,setMicCls] = useState(`${headerStyle.mrbgMicro} fa-solid fa-microphone-slash`),
		[editApoSesID,setEditApoSesID] = useState(null),
		[showLoader,setShowLoader] = useState(false),
		[filterType,setFilterType] = useState(undefined),
		searchPat = new RegExp('(^|\\s|\\(|\\[|\\.)'+searchVal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'iu');

	function changeInpVal(e){
		var val =
					e.nativeEvent.inputType==='insertFromPaste'?
						e.target.value.replace(/جلسه \d+/,'').trim():
						e.target.value;
		setSearchVal(val);
	}
	function listening(){
		if( mrbgTools.recog.listening ){
			mrbgTools.recog.stop()
			setMicCls(`${headerStyle.mrbgMicro} fa-solid fa-microphone-slash`);
		}
		else if( micCls==`${headerStyle.mrbgMicro} fa-solid fa-microphone ${headerStyle.activeMrbgMicro}` ){
			setMicCls(`${headerStyle.mrbgMicro} fa-solid fa-microphone-slash`);
		}
		else{
			mrbgTools.recog.start();
			mrbgTools.recog.mrbgTI=refInp.current;
			setMicCls(`${headerStyle.mrbgMicro} fa-solid fa-microphone ${headerStyle.activeMrbgMicro}`);
		}
	}

	useEffect(()=>{
		const unsubscribe = mrbgStore.subscribe(()=>{
			setMyNotif(mrbgStore.getState().myNotifications);
		})
		return () =>unsubscribe();
	},[])

	return(
		<li id={headerStyle.notificationPart}>
			<MrbgNotificationUpd_DT {...{myNotif,editApoSesID,setEditApoSesID,setShowLoader,formStyle}}/>
			<div id={headerStyle.notificationIcon}>
				<i>🔔</i>
				<span>{Object.keys(myNotif).length}</span>
			</div>
			{
				Object.keys(myNotif).length?
					<div id={headerStyle.notificationListFrame}>
						<div id={headerStyle.notificationList}>
							<fieldset className={headerStyle.mrbgVoice}>
								<input value={searchVal} type="search" placeholder="search" onChange={e=>changeInpVal(e)} ref={refInp}/>
								<i className={micCls} onClick={()=>listening()}></i>
							</fieldset>
							<div id={headerStyle.chooseType}>
								<fieldset>
									<label htmlFor="A">پیگیری</label>
									<input name="X" type="checkbox" id="A" value="پیگیری" checked={filterType==='پیگیری'? true: false} onClick={()=> {filterType==='پیگیری'? setFilterType(''): setFilterType('پیگیری')}}/>
								</fieldset>
								<fieldset>
									<label htmlFor="B">اکتیو</label>
									<input name="X" type="checkbox" id="B" value="اکتیو" checked={filterType==='اکتیو'? true: false} onClick={()=> {filterType==='اکتیو'? setFilterType(''): setFilterType('اکتیو')}}/>
								</fieldset>
								<fieldset>
									<label htmlFor="C">صورت حساب</label>
									<input name="X" type="checkbox" id="C" value="صورت حساب" checked={filterType==='انجام شد'? true: false} onClick={()=> {filterType==='انجام شد'? setFilterType(''): setFilterType('انجام شد')}}/>
								</fieldset>
							</div>
							<ul>
								{
									Object.keys(myNotif).map(apoSesID=>{
										if(
											( filterType && myNotif[apoSesID].notifType!==filterType ) ||
											( searchPat && !searchPat.test(`${myNotif[apoSesID].fullName} ${myNotif[apoSesID].code||''} ${myNotif[apoSesID].notifType}`) )
										)
											return ''
										else if( myNotif[apoSesID].notifType === 'پیگیری' )
											return <FollowNotif {...{...myNotif[apoSesID],showLoader,editApoSesID,headerStyle}} key={apoSesID}/>
										else if( myNotif[apoSesID].notifType === 'انجام شد' )
											return <DoneNotif {...{ ...myNotif[apoSesID], headerStyle}} key={apoSesID}/>
										else if( myNotif[apoSesID].notifType === 'اکتیو' )
											return <ActiveNotif {...{ ...myNotif[apoSesID], headerStyle}} key={apoSesID}/>
										else{
											const str = myNotif[apoSesID].notifType;
											Array.from(str).forEach((c, i) => {
												console.log(i, c, `0x${c.charCodeAt(0).toString(16)}`);
											})
											return ''
										}
									})
								}
							</ul>
						</div>
					</div>:
					''
			}
		</li>
	)
}
function ActiveNotif({apoSesID,notifType,fullName,areName,serviceTime,headerStyle}){

	function formReady( apoSesID ){
		var fs     = JSON.parse( JSON.stringify( mrbgStore.getState().formsSettings.apoSesFin ) );
		fs.hideInp = {
			...fs.hideInp,
			apoSesID: apoSesID
		};
		mrbgStore.dispatch(setSettingsForm({apoSesFin:fs}) );
		var MD = new FormData();
		MD.append('apoSesID',apoSesID);
		mrbgS2S(null, MD, 'gDt','apoAre')
	}

	return(
		<li>
			<h6 className={headerStyle.notifType}>{notifType}</h6>
			<div className={headerStyle.notFlex}>
				<table className={headerStyle.notifBody}>
					<tbody>
						<tr>
							<th className={headerStyle.headSpan}>نام: </th>
							<td className={headerStyle.valueSpan}>{fullName}</td>
						</tr>
						<tr>
							<th className={headerStyle.headSpan}>نواحی: </th>
							<td className={headerStyle.valueSpan}>{areName}</td>
						</tr>
						<tr>
							<th className={headerStyle.headSpan}>زمان: </th>
							<td className={headerStyle.valueSpan}>{serviceTime}</td>
						</tr>
					</tbody>
				</table>
				<div className={headerStyle.btnCol}>
					<i className={`fa-regular fa-power-off ${headerStyle.greenIcon}`} onClick={()=>formReady(apoSesID)}></i>
					<i className={`fa-regular fa-circle-info ${headerStyle.greenIcon}`} onClick={()=>mrbgStore.dispatch(activeFormPanel('clientsHistory__SSFrame') )} ></i>
				</div>
			</div>
		</li>
	)
}
function FollowNotif({apoSesID,notifType,code,areName,serviceDate,serviceTime,devName,tempServiceDate,tempServiceTime,remindDateTime,finalAmount,fullName,phone,deposit,showLoader,editApoSesID,headerStyle}){

	const
		[msg,setMsg] = useState('');

	function handleIssueBill(e,apoSesID){
		var MD = new FormData();
		MD.append('apoSesID',apoSesID);
		MD.append('outcomeStatus','فیکس');

		MD.append('amount',e.target.closest(`.${headerStyle.notFlex}`).querySelector('input[name="amount"]')?.value||'');

		mrbgS2S(null, MD, 'ins','FUA').
			then(x=>{if(typeof x==='string') setMsg(x)})
	}
	function handleToCancel(apoSesID){
		var MD = new FormData();
		MD.append('apoSesID',apoSesID);
		MD.append('outcomeStatus','کنسل');
		mrbgS2S(null, MD, 'ins','FUA').
			then(x=>{if(typeof x==='string') setMsg(x)})
	}
	function handleEditSession(apoSesID){
		var MD = new FormData();
		MD.append('id',apoSesID);
		mrbgS2S(null, MD, 'gDt','apoSes').
		then(x=>{ if(typeof x!=='object') setMsg(x||'') })
	}
	function readyForUpdateDate(apoSesID){
		mrbgStore.dispatch(setSundryField({formID:'notificationUpd_DT',fieldName:'beginDateTime',fieldValue:undefined}))
		mrbgStore.dispatch(setHideInp({formID:'notificationUpd_DT',fieldName:'id',fieldValue:apoSesID}))
	}

	return(
		<li className={headerStyle.followNotif}>
			<h6 className={headerStyle.notifType}>{`${notifType} ${fullName}`}</h6>
			<div className={headerStyle.notFlex}>
				<table className={headerStyle.notifBody}>
					<tbody>
						<tr>
							<th>کد نوبت: </th>
							<td>
								<span className={headerStyle.copyBtn}
									onClick={(e) => {
										navigator.clipboard.writeText(e.target.innerText);
										e.target.classList.add(headerStyle.copied);
										setTimeout(() => e.target.classList.remove(headerStyle.copied), 700);
									}}>{code.split(' ')[0]}</span>
								{` ${code.split(' ').slice(1).join(' ')}`}
							</td>
						</tr>
						<tr>
							<th>نواحی: </th>
							<td>{areName}</td>
						</tr>
						<tr>
							<th>تایم نوبت: </th>
							<td className={apoSesID==editApoSesID? showLoader?headerStyle.showLoader:headerStyle.showBorder:''}>
								<span>
									{
										apoSesID==editApoSesID && tempServiceDate?
											`${new Date(tempServiceDate).toLocaleString( 'fa-IR-u-nu-latn',{timeZone:'Asia/Tehran',year:'numeric',month:'2-digit',day:'2-digit'} ).replace( ',','' )} ${tempServiceTime}`:
											`${new Date(serviceDate).toLocaleString( 'fa-IR-u-nu-latn',{timeZone:'Asia/Tehran',year:'numeric',month:'2-digit',day:'2-digit'} ).replace( ',','' )} ${serviceTime}`
									}
								</span>
								<i onClick={()=>readyForUpdateDate(apoSesID)}>&#128197;</i>
								{devName}
							</td>
						</tr>
						<tr>
							<th>تایم پیگیری: </th>
							<td>{new Date(remindDateTime).toLocaleString( 'fa-IR-u-nu-latn',{timeZone:'Asia/Tehran',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'} ).replace( ',','' )}</td>
						</tr>
						<tr>
							<th>تلفن: </th>
							<td>{`${phone.substring(0,4)} ${phone.substring(4,7)} ${phone.substring(7)}`}</td>
						</tr>
						<tr>
							<th>بها: </th>
							<td>{finalAmount.toPrice()}</td>
						</tr>
						<tr className={headerStyle.amountFrameNot}>
							{
								deposit?
									<>
										<th>مبلغ پرداخت ‌شده:</th>
										<td>{deposit.toPrice()} تومان</td>
									</>:
									<>
										<th>پیش پرداخت:</th>
										<td><input type="number" name="amount" placeholder="مبلغ پیش پرداخت" onChange={e=>setMsg(e.target.value)}/></td>
									</>
							}
						</tr>
					</tbody>
				</table>
				<div className={headerStyle.btnCol}>
					<a href={`tel:${phone}`} className={`fa-regular fa-phone-circle ${headerStyle.greenIcon}`}></a>
					<i className={`fa-regular fa-thumbs-down ${headerStyle.redIcon} ${headerStyle.iconCircle}`} title="کنسل" onClick={()=>handleToCancel(apoSesID)}></i>
					<i className={`fa-regular fa-thumbs-up ${headerStyle.greenIcon} ${headerStyle.iconCircle}`} title="صدور صورت حساب پیش پرداخت برای قیکس شدن" onClick={e=>handleIssueBill(e,apoSesID,'')}></i>
					<i className={`fa-regular fa-pen ${headerStyle.greenIcon} ${headerStyle.iconCircle}`} title="ویرایش نوبت" onClick={()=>handleEditSession(apoSesID)}></i>
				</div>
			</div>
			{
				msg?.match(/^\d+$/)?
					<div className={headerStyle.notifMsgDiv}>{msg.toPrice()} تومان</div>:
					<div className={`${headerStyle.notifMsgDiv} ${headerStyle.redMsg}`}>{msg? parse(mrbgTools.toHtml.text(msg,headerStyle)): ''}</div>
			}
		</li>
	)
}
function DoneNotif({areName,newArea,canceledArea,postponedArea,fullName,gender,bilID,headerStyle}){
	function handleApoEnd(){
		mrbgStore.dispatch(activeFormPanel('bilPayFrame'));
		mrbgStore.dispatch(selectTagValue({formID:'bilPay',STName:'id',value:[bilID]}))
	}

	return(
		<li>
			<h6 className={headerStyle.notifType}>{`سرویس ${gender=='آقا'? 'آقای': 'خانم'} `}<span>{fullName}</span>{` انجام شد.`}</h6>
			<div className={headerStyle.notFlex}>
				<table className={headerStyle.notifBody}>
					<tbody>
					<tr>
						<th>همه نواحی: </th>
						<td>{areName}</td>
					</tr>
					<tr>
						<th>نواحی جدید: </th>
						<td>{newArea || '---'}</td>
					</tr>
					<tr>
						<th>نواحی کنسل: </th>
						<td>{canceledArea || '---'}</td>
					</tr>
					<tr>
						<th>نواحی معوق: </th>
						<td>{postponedArea || '---'}</td>
					</tr>
					</tbody>
				</table>
				<div className={headerStyle.btnCol}>
					<i className={`fa-regular fa-dollar-circle ${headerStyle.greenIcon}`} title="صورت حساب تسویه" onClick={()=>handleApoEnd()}></i>
				</div>
			</div>
		</li>
	)
}
function MrbgNotificationUpd_DT({myNotif,editApoSesID,setEditApoSesID,setShowLoader,formStyle}){

	const
		formRef = useRef(null),
		formID = 'notificationUpd_DT',
		[formSettings,setFormSettings] = useState( mrbgStore.getState().formsSettings[formID] );

	function handleSubmit(){

		setShowLoader(true);

		var MD = new FormData( document.getElementById(formStyle.notificationUpd_DT) );
		mrbgS2S(formID, MD, 'updDate','apoSes', false)
			.then(()=>{setShowLoader(false);})
	}

	useEffect(()=>{
		setEditApoSesID( formSettings?.hideInp?.id );
		if( formSettings?.hideInp?.id ){
			const apoSesID = formSettings.hideInp?.id;

			if( formRef.current?.querySelector('input[name="devID"][value="'+myNotif[apoSesID].devID+'"]') )
				formRef.current.querySelector('input[name="devID"][value="'+myNotif[apoSesID].devID+'"]').checked = true;

			// IF USER CHOOSE A DATE => UPDATE NOTIFICATION ITEM
			if( formSettings?.sundryField?.beginDateTime ){
				let
					beginDateTime = formSettings.sundryField?.beginDateTime,
					newMyNotif    = JSON.parse(JSON.stringify(myNotif)),

					[h1,m1,h2,m2] = newMyNotif[apoSesID].serviceTime.replace(' ','').split(/[:-]/).map(Number),
					duration   = (h2-h1)*60 + (m2-m1),
					startUtc = new Date(`${beginDateTime.replace(' ','T')}Z`),
					endUtc = new Date(startUtc.getTime() + duration * 60 * 1000);;

				newMyNotif[apoSesID].tempServiceDate = startUtc.toLocaleString('en-US',{timeZone:'Asia/Tehran',year:'numeric',month:'2-digit',day:'2-digit'});
				newMyNotif[apoSesID].tempServiceTime = `${startUtc.toLocaleString( 'fa-IR-u-nu-latn',{timeZone:'Asia/Tehran',hour:'2-digit', minute:'2-digit'} ).replace( ',','' )} - ${endUtc.toLocaleString('fa-IR-u-nu-latn', {timeZone:'Asia/Tehran',hour:'2-digit',minute:'2-digit'}).replace(/,/g, '')}`;
				console.log(newMyNotif)
				mrbgStore.dispatch( updateNotification(newMyNotif) );
			}

			// ELSE SET OLD BEGIN DATE FOR MRGB_PERSIAN_DATE_TIME
			else if(editApoSesID){
				// COMBINE UTC_DATE BY TEHRAN_TIME
				const
					formatDateShort = date => {
						var
							[m,d,Y,H,i,s] = date.split(/[/\-\s:]/);
						return `${Y}-${m}-${d} ${H}:${i}:${s}`;
					},
					tehranDateStr = `${myNotif[apoSesID].serviceDate}T${myNotif[apoSesID].serviceTime.split(' - ')[0]}:00`,
					beginDateTime =
						new Date(tehranDateStr)
							.toLocaleString('en-US',{timeZone:'utc',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit', minute:'2-digit',second:'2-digit',hour12: false})
							.replace( /,\s*/, ' ' );

				if( formRef.current )
					mrbgTools.triggerChange( formRef.current.querySelector('input[name="beginDateTime"]'), formatDateShort(beginDateTime) )
			}
		}
	},[formSettings,editApoSesID])
	useEffect(() => {
		const unsubscribe = mrbgStore.subscribe(()=>{
			setFormSettings( mrbgStore.getState().formsSettings[formID] )
		});
		return ()=>unsubscribe()
	}, []);

	if( !editApoSesID )
		return '';

	return (
		<div id={formStyle.notificationUpd_DTFrame} ref={formRef}>
			<div>
				<div onClick={()=>handleSubmit()}>Update</div>
				<i className="fa-solid fa-close" onClick={()=>document.getElementById(formStyle.notificationUpd_DT).mrbgReset()}></i>
			</div>
			<MrbgFormsCreator {...{formID,...formsJson.EP.apoSes.forms[formID],formStyle}}/>
		</div>
	)
}
export default MrbgNotifications;